export const ADMIN_UPLOADER_CHANNEL = "torahanytime.admin-uploader";
export const ADMIN_UPLOADER_PROTOCOL_VERSION = 1;

export function adminUploaderMessage(type, data = {}) {
  return {
    channel: ADMIN_UPLOADER_CHANNEL,
    type,
    version: ADMIN_UPLOADER_PROTOCOL_VERSION,
    ...data,
  };
}

/** Keep unrelated window messages out of the privileged uploader bridge. */
export function isAdminUploaderMessage(value) {
  return (
    value &&
    typeof value === "object" &&
    value.channel === ADMIN_UPLOADER_CHANNEL &&
    value.version === ADMIN_UPLOADER_PROTOCOL_VERSION &&
    typeof value.type === "string"
  );
}
